// extracted by mini-css-extract-plugin
module.exports = {"container":"textControls_container__KplAG","label":"textControls_label__2AxH1","segmentItem":"textControls_segmentItem__3WhUV"};